<template>
  <div>
    <div class="type-wrap" v-for="(v,i) in list" :key="v.id" :class="{'rank-right': i==0&&!v.wbsLiveLibraryVos.length}">
      <div class="list-wrap">
        <look-more class="look-more-title" :title="v.name" :index="i" :data="v" @lookMore="lookMore(v)"/>
        <template v-if="v&&v.wbsLiveLibraryVos&&v.wbsLiveLibraryVos.length">
          <template v-if="i==0">
            <list class="list-item list-first-type" :class="{'first-item': !i,'first-item-second': !i&&(index+1)%3==0}" @look="handLook" v-for="(item,index) in v.wbsLiveLibraryVos.slice(0,6)" :key="item.id" :item="item"></list>
          </template>
          <template v-else>
            <list class="list-item" :class="{'first-item': !i,'first-item-second': !i&&(index+1)%3==0}" @look="handLook" v-for="(item,index) in v.wbsLiveLibraryVos.slice(0,4)" :key="item.id" :item="item"></list>
          </template>
        </template>
        <div class="no-data" v-else >暂无数据</div>
      </div>
      <hot-rank class="rank-wrap" ref="rank" :list="rankList" v-if="!i">
        <template slot="rank-title">嘉实热播榜</template>
      </hot-rank>
    </div>
  </div>
</template>
<script>
import { getLcWeb } from '@/api/lc_web'
import HotRank from '@/components/rank'
import List from '@/views/components/list'
import LookMore from '@/views/components/lookMore'
import { cloneDeep } from 'lodash'
export default {
  data () {
    return {
      list: [],
      rankList: []
    }
  },
  components: {
    HotRank,
    List,
    LookMore
  },
  mounted () {
    this.getList()
    this.getRank()
  },
  methods: {
    // 列表查询
    getList () {
      const obj = {
        name: 'lc.market.content.listCategory',
        data: {}
      }
      getLcWeb(obj).then(res => {
        if (res.code === 0) {
          const temp = res.value ? res.value : []
          this.list = cloneDeep(temp).filter(v => {
            return Number(v.showStatus) === 1
          })
        } else {
          this.$showError(res.msg)
        }
      })
    },
    // 热播排行榜查询
    getRank () {
      const obj = {
        name: 'lc.hot.bord',
        data: {}
      }
      getLcWeb(obj).then(res => {
        if (res.code === 0) {
          this.rankList = res.rows ? res.rows : []
        } else {
          this.$showError(res.msg)
        }
      })
    },
    /* 跳转至更多列表页 */
    lookMore (val) {
      this.$router.push({
        name: 'live',
        query: {
          id: val.id
        }
      })
    },
    /* 查看详情 */
    handLook (val) {
      this.$router.push({
        name: 'marketing',
        query: {
          id: val.id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.type-wrap{
  display:flex;
}
.list-wrap{
  flex:1;
  width:100%;
}
.list-item{
  width:calc((100% - 72px) / 4);
}
.list-item:nth-child(4n+5){
  margin-right:0;
  padding-right:0;
}
.list-wrap ::v-deep .title-show{
  padding-top:24px!important;
}
.first-item{
  width:calc((100% - 48px) / 3);
}
.first-item-second {
  margin:0;
  padding:0;
}
.rank-wrap{
  width:calc(25% - 24px);
  margin-left:24px;
}
.rank-right{
  justify-content: flex-end;
}
.no-data {
  // background:#fff;
  // padding:48px 2px;
  // text-align:center;
}
.list-first-type:nth-child(3n+2){
  margin-right:24px;
}
</style>
